import { render, staticRenderFns } from "./HomeCovi19.vue?vue&type=template&id=2fbab596&scoped=true"
import script from "./HomeCovi19.vue?vue&type=script&lang=ts"
export * from "./HomeCovi19.vue?vue&type=script&lang=ts"
import style0 from "./HomeCovi19.vue?vue&type=style&index=0&id=2fbab596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbab596",
  null
  
)

export default component.exports